import { useEffect, useState } from 'react';
import TcPagination from './TcPagination';

export function useClientPage<T>(items: T[], initialSize = 10) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialSize);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize) || 1);
  const safePage = Math.min(page, totalPages);

  useEffect(() => {
    if (page !== safePage) setPage(safePage);
  }, [page, safePage]);

  const slice = items.slice((safePage - 1) * pageSize, safePage * pageSize);
  const pager = (
    <TcPagination
      page={safePage}
      totalPages={totalPages}
      total={total}
      pageSize={pageSize}
      onPageChange={setPage}
      onPageSizeChange={(size) => {
        setPageSize(size);
        setPage(1);
      }}
      itemLabel="itens"
    />
  );

  return { slice, pager };
}
